"use client";

import { campaignDetailsSchema } from "../../../../lib/types/schema/campaign/campaignDetailsSchema";
import type { UseRequestQueryProps } from "../../../../request/hooks/useRequestQuery";
import { useRequestQuery } from "../../../../request/hooks/useRequestQuery";
import { keyCampaignDetails } from "./keyCampaignDetails";

export type UseRequestCampaignDetailsProps = UseRequestQueryProps & {
  id: number;
};

export const useRequestCampaignDetails = ({
  id,
  ...props
}: UseRequestCampaignDetailsProps) => ({
  query: useRequestQuery({
    ...props,
    queryFnRequestProps: {
      schema: campaignDetailsSchema,
      urlBackendPath: `/campaign-details/${id}`,
    },
    queryKey: keyCampaignDetails({ id }),
  }),
});
